module.exports = __webpack_public_path__ + "img/pr-1.36ed7c8c.png";